import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type VerificationRequest = {
  id: string;
  email: string;
  role: string;
  is_verified: boolean;
  created_at: string;
};

const useAdminVerificationRequests = () => {
  const queryFn = async (): Promise<VerificationRequest[]> => {
    const { data, error } = await supabaseClient
      .from('users')
      .select('*')
      .eq('role', 'business_provider')
      .eq('is_verified', false)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching verification requests:', error);
      throw new Error(error.message);
    }

    return data || [];
  };

  return useQuery<VerificationRequest[], Error>({
    queryKey: ['admin-verification-requests'],
    queryFn,
  });
};

export default useAdminVerificationRequests;
